const waitForElement = `{
  "wait_for": "p"
}`;

export default waitForElement;
